import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { IColor, IProductColorRequest } from '../models/models'

export class UpdateColorCodeApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/color/updateColorCode',
      requesterInfo,
    })
  }

  public async updateColor(request: IColor): Promise<any> {
    return await this.postAsync<any>(request)
  }
}
